'use client'

import { observer } from 'mobx-react-lite'
import Link from 'next/link'
import { FAVOURITE, SLIDER_CLASS_NAME } from '@/constants'
import { FavouriteIcon } from '../fav-icon'
import {
  ArticleCard,
  ArticleCardChip,
  ArticleCardContent,
  ArticleCardFavoriteIconContainer,
  ArticleCardTitle,
  ArticleImage,
  ArticleImageContainer,
} from './article-grid-item.style'
import { useMemo } from 'react'
import cx from 'classnames'

// Only the fields the card renders, so callers can pass a narrow query result
// instead of a whole article.
export type ArticleGridItemArticle = {
  id: number
  path: string | null
  title: string | null
  hero_image_ref?: { url: string | null; alt: string | null } | null
  article_tags?: { tag: { name: string } | null }[]
}

type ArticleSingleProps = {
  article: ArticleGridItemArticle
  className?: string
  tagName?: string
}

/**
 * @deprecated USE V2ArticleTile instead
 */
const ArticleGridItem = ({
  article,
  className,
  tagName,
}: ArticleSingleProps) => {
  const showTagName = useMemo(
    () => (tagName ? tagName : article.article_tags?.[0]?.tag?.name),
    [article.article_tags, tagName]
  )

  return (
    <Link href={`${article.path}`}>
      <ArticleCard className={cx(SLIDER_CLASS_NAME, className)}>
        <ArticleCardFavoriteIconContainer>
          <FavouriteIcon itemId={article.id} type={FAVOURITE.ARTICLE} />
        </ArticleCardFavoriteIconContainer>
        <ArticleImageContainer>
          <ArticleImage
            src={article.hero_image_ref?.url ?? ''}
            alt={article.hero_image_ref?.alt ?? ''}
            width={400}
            height={600}
          />
        </ArticleImageContainer>
        <ArticleCardContent>
          {showTagName && (
            <ArticleCardChip>
              {tagName ? tagName : article.article_tags?.[0]?.tag?.name}
            </ArticleCardChip>
          )}
          <ArticleCardTitle>{article.title}</ArticleCardTitle>
        </ArticleCardContent>
      </ArticleCard>
    </Link>
  )
}

export default observer(ArticleGridItem)
